import { render, staticRenderFns } from "./RepoPreview.vue?vue&type=template&id=670263fa&"
import script from "./RepoPreview.vue?vue&type=script&lang=js&"
export * from "./RepoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports